export const RouterPayment = [
  {
    path:"/payment", // 支付页面
    name:"",
    component: (resolve) => require(/* webpackChunkName: "payment" */ ["@/views/payment/Payment"], resolve),
  },
  {
    path: "/pay/success", // 支付成功
    name: "支付结果",
    component: (resolve) => require(/* webpackChunkName: "payment" */ ["@/views/payment/Success"], resolve),
  },
  {
    path: "/pay/failed", // 其他日期
    name: "支付结果",
    component: (resolve) => require(/* webpackChunkName: "payment" */ ["@/views/payment/Failed"], resolve),
  },
];
